import { useEffect, useState, useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { getLocaleName } from './getLocaleName';

export const useYotpo = () => {
  const [locale, setLocale] = useState('AU');

  const { yotpo, environment, host, locale_mapping } = useSelector(
    (state) => ({
      yotpo: state.app.context?.project?.data.yotpo,
      environment: state.app.context?.environment,
      host: state.app.context?.host,
      locale_mapping: state.app.context?.project?.data.locale_mapping,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (locale_mapping) {
      setLocale(getLocaleName(locale_mapping));
    }
  }, [locale_mapping]);

  const isStagingEnv = environment === 'dev' || host?.includes('test.') || host?.includes('.loca');

  const getYotpoConfig = useCallback(
    (prodAU, prodNZ, stAU, stNZ) => {
      if (isStagingEnv) {
        return locale === 'NZ' ? stNZ : stAU;
      }
      return locale === 'NZ' ? prodNZ : prodAU;
    },
    [isStagingEnv, locale],
  );

  const getYotpoScriptUrl = () =>
    getYotpoConfig(yotpo?.url_prod_au, yotpo?.url_prod_nz, yotpo?.url_st_au, yotpo?.url_st_nz);

  const getProductRating = () =>
    getYotpoConfig(
      yotpo?.productRatingProdAU,
      yotpo?.productRatingProdNZ,
      yotpo?.productRatingStAU,
      yotpo?.productRatingStNZ,
    );

  const getReviewSummary = () =>
    getYotpoConfig(
      yotpo?.reviewSummaryProdAU,
      yotpo?.reviewSummaryProdNZ,
      yotpo?.reviewSummaryStAU,
      yotpo?.reviewSummaryStNZ,
    );

  const getAskQuestion = () => getYotpoConfig(yotpo?.QAProdAU, yotpo?.QAProdNZ, yotpo?.QAStAU, yotpo?.QAStNZ);

  const getInstaBlock = () =>
    getYotpoConfig(yotpo?.instaBlockProdAU, yotpo?.instaBlockProdNZ, yotpo?.instaBlockStAU, yotpo?.instaBlockStNZ);

  const getInstaProductBlock = () =>
    getYotpoConfig(
      yotpo?.instaProductBlockProdAU,
      yotpo?.instaProductBlockProdNZ,
      yotpo?.instaProductBlockStAU,
      yotpo?.instaProductBlockStNZ,
    );

  return {
    getYotpoScriptUrl,
    getProductRating,
    getReviewSummary,
    getAskQuestion,
    getInstaBlock,
    getInstaProductBlock,
  };
};
